import type { NavItem } from '@/api/types'

// The coded default for the public Broadsheet subnav, mirroring the legacy site's primary links.
// It is the always-available fallback (when GET /api/v1/nav/main returns [] — i.e. no menu saved
// yet, or the request fails) AND the seed the future admin editor starts from. Once an admin saves,
// the stored menu replaces this at runtime. The auth-gated "Sign in"/account entry is intentionally
// NOT here — it stays coded in AppSubnav (it needs auth reactivity).
export const defaultNav: NavItem[] = [
  { label: 'Attend', href: '/attend', external: false },
  { label: 'Event Submission', href: '/event', external: false },
  { label: 'Events List', href: '/events', external: false },
  { label: 'Registration', href: '/registration', external: false },
  { label: 'Dealers', href: '/dealers', external: false },
  { label: 'FAQs', href: '/faqs', external: false },
]
